<div
  class="payment-wrapper"
  [class.light-theam]="isLightTheam"
  dir="ltr"
  [class.arebic-text]="textDirection === 'rtl'"
>
  <ul>
    @for (
      installment of sliderAmount;
      track $index;
      let index = $index,
          even = $even,
          odd = $odd,
          last = $last,
          first = $first,
          count = $count
    ) {
      <li class="payment-plan" [class.islast]="last">
        <div [class.right-10]="textDirection === 'rtl'">
          @if (first) {
            <img
              [src]="isLightTheam ? installment?.lightImgUrl : installment?.darkImgUrl"
              alt="Installment Plan {{ index }}"
            />
          } @else {
            <img
              [src]="isLightTheam ? installment.lightImgUrl : installment.darkImgUrl"
              alt="Installment Plan {{ index }}"
            />
          }
          <span [class.isFirst]="first">{{ installment.label }}</span>
        </div>
        <span [class.isFirst]="first">
          {{ 'KD' | translate }} {{ installment?.amount | number: '1.3-3' }}
        </span>
      </li>
    }
  </ul>

  <hr [class.ml-0]="textDirection === 'rtl'" />
  <div class="total cust-total">
    <div [class.pl-40]="textDirection === 'rtl'">
      <span class="amount"> {{ 'HOME_PAGE.SARIA_COMPLAINT' | translate }}</span>
    </div>
    <span class="amount" translate>
      <span>{{ 'KD' | translate }} {{ orderAmount | number: '1.3-3' }}</span>
    </span>
  </div>
</div>
